import React from "react";

export default function Footer() {
  return (
    <div className="Footer text-center mb-3 mt-5">
      <a
        href="https://github.com/TetianaIvashyna/weather-react-app"
        target="_blank" rel="noreferrer"
      >
        Open source code
      </a>
      , by Tanja Ivashyna
    </div>
  );
}
